/*
Copyright (c) 2026 Wind River Systems, Inc.

The right to copy, distribute, modify, or otherwise make use of this software may be licensed only pursuant to the terms of an applicable Wind River license agreement.
*/
import { Component } from '@angular/core';
import { environment } from '@environment';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'usp-installation-guide',
  templateUrl: './installation-guide.component.html',
  styleUrls: ['./installation-guide.component.scss']
})
export class InstallationGuideComponent {
  // Provide configuration of URLs in otherwise static HTML content
  readonly supportUrl = environment.supportUrl;
  // readonly esdCenterUrl = environment.esdCenterUrl;
  readonly documentationUrl = environment.documentationUrl;
  readonly offlineVideoUrl = environment.offlineVideoUrl;
  readonly onlineVideoUrl = environment.onlineVideoUrl;
  readonly syncClientVideoUrl = environment.syncClientVideoUrl;
}
